import { Divider, Row, Typography } from 'antd';
import React, { memo } from 'react';

const { Text, Title } = Typography;

interface IDrawing {
  description: string;
  mimeDataName: string;
  subDrawings: IDrawing[];
}

interface IProps {
  drawing: IDrawing;
}

export const Drawing: React.FC<IProps> = memo(({ drawing }) => {
  return (
    <>
      {drawing && (
        <>
          <Title level={4}>{drawing.description}</Title>
          {drawing.mimeDataName && <img alt='' width={600} src={drawing.mimeDataName} />}
          {drawing.subDrawings?.map((subDrawing, index) => {
            return (
              <Row key={`${subDrawing.description}${index}`}>
                <Text>{subDrawing.description}</Text>
                {subDrawing.mimeDataName && <img alt='' width={600} src={subDrawing.mimeDataName} />}
              </Row>
            );
          })}
          <Divider />
        </>
      )}
    </>
  );
});
